<template>
    <div>
        <v-row justify="space-between">
            <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <h1 class="headline font-weight-light">Pending Case</h1>
            </v-col>
            <v-col cols="12" sm="12" md="6" class="fix-flex-end-row">
                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-if="role_name != 'Admin'"
                            fab
                            small
                            :color="
                                chk_export_data == false ? 'green accent-3' : ''
                            "
                            class="mr-1"
                            @click="export_data()"
                            v-bind="attrs"
                            v-on="on"
                            :disabled="chk_export_data == true"
                        >
                            <v-icon
                                v-if="chk_export_data == false"
                                color="teal darken-4"
                                >mdi-file-excel</v-icon
                            >
                            <img
                                v-if="chk_export_data == true"
                                src="../../../assets/all/Loading.gif"
                                style="width: 6%"
                            />
                        </v-btn>
                    </template>
                    <span>Export Data</span>
                </v-tooltip>

                <v-text-field
                    class="ma-0"
                    v-model="form.searchtext"
                    clearable
                    dense
                    rounded
                    outlined
                    @input="
                        chk_active_btn = 0
                        form.status = ''
                        form.projects = []
                        form.branchs = []
                        form.case_type = []

                        pagination.current = 1
                        getCase()
                        getSummary()
                    "
                >
                    <template v-slot:label>
                        <v-icon style="vertical-align: middle"
                            >mdi-magnify</v-icon
                        >Case ID / Serial / Site Name / PO Number
                    </template>
                </v-text-field>
            </v-col>
        </v-row>
        <v-row no-gutters class="mb-2">
            <v-col cols="12" md="4">
                <v-autocomplete
                    class="pr-3"
                    :items="projects"
                    v-model="form.projects"
                    item-text="project_name"
                    item-value="project_id"
                    multiple
                    outlined
                    dense
                    clearable
                    @blur="get_data()"
                >
                    <template v-slot:label>
                        <v-icon
                            small
                            class="mb-1"
                            style="vertical-align: middle"
                            >mdi-filter</v-icon
                        >Filter Project
                    </template>
                    <template v-slot:selection="{ item, index }">
                        <v-chip small v-if="index < 3">
                            <span>{{ item.project_name }}</span>
                        </v-chip>
                        <span v-if="index === 3" class="grey--text caption">
                            (+{{ form.projects.length - 3 }}
                            others)
                        </span>
                    </template>
                </v-autocomplete>
            </v-col>
            <v-col cols="6" md="4">
                <v-autocomplete
                    class="pr-3"
                    :items="branchs"
                    v-model="form.branchs"
                    item-text="branch_name"
                    item-value="branch_id"
                    multiple
                    clearable
                    outlined
                    dense
                    @click:clear="get_data(), (form.engineer = '')"
                    @blur="get_data(), getbkkengineer()"
                >
                    <template v-slot:label>
                        <v-icon
                            small
                            class="mb-1"
                            style="vertical-align: middle"
                            >mdi-filter</v-icon
                        >Filter Branch / Zone
                    </template>
                    <template v-slot:selection="{ item, index }">
                        <v-chip small v-if="index < 2">
                            <span>{{ item.branch_name }}</span>
                        </v-chip>
                        <span v-if="index === 3" class="grey--text caption">
                            (+{{ form.branchs.length - 3 }}
                            others)
                        </span>
                    </template>
                </v-autocomplete>
            </v-col>
            <v-col v-if="team_name == 'NONHP'" cols="6" md="4">
                <v-autocomplete
                    class="pr-3"
                    :items="owners"
                    v-model="form.owner"
                    item-text="created_name"
                    item-value="created_by"
                    clearable
                    outlined
                    dense
                    @click:clear="get_data(), (form.engineer = '')"
                    @blur="get_data(), getbkkengineer()"
                >
                    <template v-slot:label>
                        <v-icon
                            small
                            class="mb-1"
                            style="vertical-align: middle"
                            >mdi-filter</v-icon
                        >Filter Owner
                    </template>
                    <!-- <template v-slot:selection="{ item, index }">
            <v-chip small v-if="index < 2">
              <span>{{ item.created_name }}</span>
            </v-chip>
            <span v-if="index === 3" class="grey--text caption">
              (+{{ form.owner.length - 3 }}
              others)
            </span>
          </template> -->
                </v-autocomplete>
            </v-col>
            <v-col v-if="arr_case_type.length > 1" cols="6" md="4">
                <v-autocomplete
                    class="pr-3"
                    :items="arr_case_type"
                    v-model="form.case_type"
                    multiple
                    clearable
                    outlined
                    dense
                    @click:clear="get_data()"
                    @blur="get_data()"
                >
                    <template v-slot:label>
                        <v-icon
                            small
                            class="mb-1"
                            style="vertical-align: middle"
                            >mdi-filter</v-icon
                        >Filter Job Type
                    </template>
                    <template v-slot:selection="{ item, index }">
                        <v-chip small v-if="index < 2">
                            <span>{{ item }}</span>
                        </v-chip>
                        <span v-if="index === 2" class="grey--text caption">
                            (+{{ form.case_type.length - 2 }}
                            others)
                        </span>
                    </template>
                </v-autocomplete>
            </v-col>
            <v-col v-if="condition.team != 'NONHP'" cols="12" md="4">
                <v-autocomplete
                    v-model="form.special_status"
                    :items="special"
                    class="ml-5 mr-2"
                    label="Special Status"
                    outlined
                    dense
                    clearable
                    @click:clear="get_data()"
                    @change="get_data()"
                ></v-autocomplete>
            </v-col>
            <v-col v-if="visibleengineerbkk" cols="12" md="4">
                <v-autocomplete
                    v-model="form.engineer"
                    :items="engineerbkk"
                    item-text="emp_name_en"
                    item-value="emp_id"
                    class="ml-5 mr-2"
                    label="Engineer"
                    clearable
                    outlined
                    dense
                    @change="get_data()"
                ></v-autocomplete>
            </v-col>
            <v-col
                cols="2"
                v-if="
                    team_name == 'IPG' ||
                        team_name == 'PSG' ||
                        team_name == 'SUPPORTUC'
                "
            >
                <v-switch
                    v-model="ismart"
                    flat
                    label="iSmart"
                    @change="get_data()"
                ></v-switch>
            </v-col>
            <v-col cols="12" v-if="(summarytab = true)">
                <v-row justify="start">
                    <v-col
                        v-if="num_total > 0"
                        cols="6"
                        xs="6"
                        sm="4"
                        md="3"
                        lg="2"
                        xl="2"
                        class="cur-p"
                    >
                        <v-card @click="selectCard(0, '')">
                            <v-list-item>
                                <v-row no-gutters align="center">
                                    <v-col cols="9">
                                        <b style="font-size: 15px"
                                            >All Pending</b
                                        >
                                    </v-col>
                                    <v-col cols="3">
                                        <v-btn
                                            fab
                                            dark
                                            small
                                            elevation="0"
                                            :color="
                                                0 === chk_active_btn
                                                    ? 'orange'
                                                    : 'teal darken-1'
                                            "
                                        >
                                            <span>{{ num_total }}</span>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-list-item>
                            <v-system-bar
                                :height="4"
                                dark
                                :color="
                                    0 === chk_active_btn ? 'orange' : 'white'
                                "
                            ></v-system-bar>
                        </v-card>
                    </v-col>
                    <v-col
                        cols="6"
                        xs="6"
                        sm="4"
                        md="3"
                        lg="2"
                        xl="2"
                        class="cur-p"
                        v-for="(item, index) in arr_card"
                        :key="index + 1"
                    >
                        <v-card @click="selectCard(index + 1, item.title)">
                            <v-list-item>
                                <v-row no-gutters align="center">
                                    <v-col cols="9">
                                        <b style="font-size: 15px">
                                            {{ item.title }}
                                        </b>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-btn
                                            fab
                                            dark
                                            small
                                            elevation="0"
                                            :color="
                                                index + 1 === chk_active_btn
                                                    ? 'orange'
                                                    : 'teal darken-1'
                                            "
                                        >
                                            <span>{{ item.num_cases }}</span>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-list-item>
                            <v-system-bar
                                :height="4"
                                dark
                                :color="
                                    index + 1 === chk_active_btn
                                        ? 'orange'
                                        : 'white'
                                "
                            ></v-system-bar>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
            <v-col v-else-if="summarytab == false">
                <v-progress-linear
                    indeterminate
                    color="cyan"
                ></v-progress-linear>
            </v-col>
        </v-row>

        <table-view-case
            @getCase="getCase"
            @getSummary="getSummary"
            :condition="condition"
            :data_case="data_case"
            :casetab="casetab"
        />

        <div class="text-center pa-5">
            <v-pagination
                @input="onPageChange"
                v-model="pagination.current"
                :length="data_case.last_page"
                total-visible="10"
                circle
            ></v-pagination>
        </div>
        <div id="snackbar" class="d-print-none">
            <v-snackbar v-model="snackbar" color="success" right>
                {{ text }}
            </v-snackbar>
        </div>
    </div>
</template>

<script>
import axios from "axios"

import { mapState, mapMutations } from "vuex"

import TableViewCase from "../components/TableViewCase"
import MaterialStatsCard from "../../../components/StatsCard"
import ViewCdax from "../../../components/ViewCdax"
export default {
    components: {
        "view-cdax": ViewCdax,
        "table-view-case": TableViewCase,
        "base-material-stats-card": MaterialStatsCard,
    },
    computed: {
        ...mapState(["snackbar"]),
        ...mapState(["isLoading"]),
    },
    mounted() {
        this.getCase()
        this.getSummary()
        this.getProject()
    },
    data() {
        return {
            data_post: {
                project_id: [],
                branch_id: [],
                case_type: [],
                engineer: "",
                special_status: "",
                owner: "",
                ismart: "",
            },
            team_name: localStorage.team_name,
            ismart: false,
            owners: [],
            team_name: localStorage.team_name,
            summarytab: false,
            casetab: false,
            role_name: localStorage.role_name,
            text: "Success, Your work has been saved",
            caseid: 0,
            advanced_filter: false,
            autolog: "",
            data_pickup: [],
            status_log: null,
            text_copy: "",
            reasonR: [(v) => !!v || "Reason is required"],
            valid: false,
            reason: "",
            buttonstatus: "",
            maincase_id_changestatus: 0,
            dialogchangestatus: false,
            dialogconfirm: false,
            no: 1,
            data: [],
            condition: {
                team: this.$route.params.team,
                status: "ViewDetail",
            },
            search: "",
            url: process.env.VUE_APP_ROOT_API,
            data_case: [],
            form: {
                owner: "",
                projects: [],
                status: "",
                searchtext: "",
                case_type: [],
                branchs: [],
                engineer: "",
                ismart: "",
            },
            arr_case_type: [],
            projects: [],
            branchs: [],
            status: [],
            pagination: {
                current: 1,
            },
            data_summary: [],
            arr_card: [],
            chk_active_btn: 0,
            num_total: 0,
            engineerbkk: [],
            visibleengineerbkk: false,
            chk_export_data: false,
            special: ["CRT", "uncontrol"],
        }
    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),
        ...mapMutations(["mutateIsLoading"]),
        get_data: _.debounce(async function(e) {
            this.chk_active_btn = 0
            this.form.status = ""
            this.form.searchtext = ""

            this.getSummary()
            this.getCase()

            if (this.form.branchs.length == 0) {
                this.visibleengineerbkk = false
            }
        }, 1500),
        async getSummary() {
            this.summarytab = false
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            this.data_post = {
                project_id: [],
                branch_id: [],
                case_type: [],
                engineer: "",
                special_status: "",
                owner: "",
                ismart: "",
            }
            this.data_post.ismart = this.ismart == false ? "N" : "Y"
            this.data_post.project_id = this.form.projects
            this.data_post.branch_id = this.form.branchs
            this.data_post.case_type = this.form.case_type
            this.data_post.engineer = this.form.engineer
            this.data_post.special_status = this.form.special_status
            if (
                this.form.owner != "" &&
                this.form.owner != null &&
                this.form.owner != undefined
            ) {
                this.data_post.owner = this.form.owner
            } else {
                this.data_post.owner = ""
            }
            // console.log(this.data_post)
            const url = `${process.env.VUE_APP_ROOT_API}/api/case-pending-summary`
            try {
                const { data } = await axios.post(
                    `${url}`,
                    this.data_post,
                    options
                )
                // console.log(data, "hh")
                // this.data_summary = data;
                this.arr_card = data
                this.num_total = 0
                this.arr_card.map((each) => {
                    this.num_total += parseInt(each.num_cases)
                })
                this.summarytab = true
            } catch (error) {
                console.log(error)
            }
        },
        getCase: _.debounce(async function(e) {
            this.casetab = false
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            this.form.ismart = this.ismart == false ? "N" : "Y"

            const url = `${process.env.VUE_APP_ROOT_API}/api/allcase?page=${this.pagination.current}`
            // console.log(url)
            try {
                const { data } = await axios.post(`${url}`, this.form, options)
                this.pagination.current = data.current_page
                this.data_case = data
                console.log(this.data_case, "-pp")
                this.casetab = true
            } catch (error) {
                console.log(error)
            }
        }, 1000),
        async getProject() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/filtercase`
            try {
                const { data } = await axios.get(`${url}`, options)
                // console.log(data, "hhd")
                this.projects = data.projects
                this.status = data.main_status
                this.branchs = data.branchs
                this.owners = data.owner
                this.arr_case_type = data.case_type
            } catch (error) {}
        },
        onPageChange() {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
            })
            this.getCase()
        },
        selectCard(i, params) {
            console.log("--ลล")
            this.chk_active_btn = i
            this.form.status = params
            this.pagination.current = 1
            this.getCase()
            this.getSummary()
            this.form.searchtext = ""
        },
        async getbkkengineer() {
            if (this.form.branchs.length == 1) {
                const url = `${process.env.VUE_APP_ROOT_API}/api/svc-ce-branch/${this.form.branchs[0]}`
                try {
                    const { data } = await axios.get(`${url}`)
                    this.engineerbkk = data[0].engineer
                    this.visibleengineerbkk = true
                } catch (error) {
                    console.log(error)
                }
            }
        },
        async export_data() {
            this.chk_export_data = true
            this.form.ismart = this.ismart == false ? "N" : "Y"

            await axios({
                url: `${process.env.VUE_APP_ROOT_API}/api/export-pending`,
                method: "POST",
                responseType: "blob",
                data: this.form,
                headers: { Authorization: "Bearer " + localStorage.token },
            }).then((response) => {
                this.chk_export_data = false
                let fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                )
                let fileLink = document.createElement("a")

                fileLink.href = fileURL
                fileLink.setAttribute("download", "report.xlsx")
                document.body.appendChild(fileLink)

                fileLink.click()
            })
        },
    },
}
</script>
<style>
.v-input__slot {
    margin-left: 0px !important;
}
</style>
